class PayrollPeriod {
  constructor(data) {
    data = data || {};
    this.id = data.id || null;
    this.pay_date = data.pay_date || null;
    this.locked = data.locked || null;
    this.locked_date = data.locked_date || null;
    this.locked_by_users_id = data.locked_by_users_id || null;
    this.start_date = data.start_date || null;
    this.end_date = data.end_date || null;
    this.approval_cutoff_date = data.approval_cutoff_date || null;
  }
}

export default PayrollPeriod;
